// 数据请求
import vue from 'vue'
vue.prototype.$http = getDate
 let _this = vue
function getDate(url,config) {
    var token = window.sessionStorage.getItem("token");
    return new Promise((resolve, reject) => {
        if(config) {
            LYCom.AsynCallBiz(
                function (e) {
                    if (e.err) {
                        if(e.err ==='BizSvrErr:token失效'){
                            window.location.href = '/#/login';
                            console.log(e.err);
                        }
                        reject(e.err)
                    } else {
                        if (e.rtnObj) {
                            var result = e.rtnObj;
                            resolve(result)
                        }
                    }
                },
                url,
                token,
                ...config
            );
        }else{
            LYCom.AsynCallBiz(
                function (e) {
                    if (e. err) {
                        reject(e.err)
                    } else {
                        if (e.rtnObj) {
                            var result = e.rtnObj;
                            resolve(result)
                        }
                    }
                },
                url,
                token
            );
        }

    })
}



// WEBPACK FOOTER //
// ./src/network/request.js